import templateUrl from 'emun.salesrep/salesrep-pending-orders.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import orderConfig from 'emun.order/order.config';

class SalesRepPendingOrdersController {
  constructor($rootScope) {
    const $ctrl = this;
    basicController($ctrl);
    var context = $ctrl.context || 'rep';
    var repFilter = "";
    $ctrl.orderConfig = orderConfig;
    var filter = "SalesRepID";
    if (context == 'manager') { filter = "ManagerId"; }
    if (context == 'vendor') {
      filter = "VendorId";
    } else if (context == 'subrep') {
      filter = 'SubRepId';
    }
    repFilter = filter + "=" + this.repId;

    if (context == "executive") {
      repFilter = "";
    }

    $ctrl.pendingOrders = new AutoQuery({
      url: 'QueryCartsJoin.json?Status=Open&Exported=True&ClientVersionNotEqualTo=%20&' + repFilter,
      orderBy: '-OrderedOn',
      autoLoad: true,
      pageSize: 10,
      scrollTop: false
    })
  }
}

let SalesRepPendingOrders = {
  bindings: {
    repId: '@',
    context: '@',
    title: '@'
  },
  controller: SalesRepPendingOrdersController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default SalesRepPendingOrders